@let isActionLoading = actionLoadingStatus() === LoadingState.LOADING;

<div class="service-center-modal">
  <h2 class="service-center-modal__title">
    {{ titleTranslateKey | translate }}
  </h2>

  <form
    class="service-center-modal__form"
    [formGroup]="serviceCenterForm"
    (ngSubmit)="onSubmit()"
  >
    <lib-input
      class="service-center-modal__field"
      formControlName="name"
      [label]="'monitoring.service-centers.modal.fields.name' | translate"
      [placeholder]="'monitoring.service-centers.modal.fields.name' | translate"
    />

    <lib-textarea
      class="service-center-modal__field"
      formControlName="address"
      [label]="'monitoring.service-centers.modal.fields.address' | translate"
      [placeholder]="'monitoring.service-centers.modal.fields.address' | translate"
    />

    <lib-textarea
      class="service-center-modal__field"
      formControlName="contactInfo"
      [label]="'monitoring.service-centers.modal.fields.contact-info' | translate"
      [placeholder]="'monitoring.service-centers.modal.fields.contact-info' | translate"
    />

    <div class="service-center-modal__actions">
      <lib-button
        buttonStyle="transparent-tertiary"
        buttonType="button"
        [disabled]="isActionLoading"
        (click)="closeModal(false)"
      >
        {{ 'monitoring.service-centers.modal.actions.cancel' | translate }}
      </lib-button>

      <lib-button
        buttonStyle="primary"
        buttonType="submit"
        [disabled]="serviceCenterForm.invalid || isActionLoading"
      >
        {{ 'monitoring.service-centers.modal.actions.save' | translate }}
      </lib-button>
    </div>
  </form>
</div>
